<div class="backgroundColor mine-shaft base">
  <section class="container-fluid backgroundColor mine-shaft base d-flex align-items-center position-relative top-119">
    <div class="col-md-12">
      <div id="row" class="container">
        <div class="row pt-20">
          <div class="col-md-12 no-padd">
            <div class="bg-yellow-gradient text-shadow">
              <h1 class="py-2 m-6 mt-16 mb-16 a-font-style font-italic textColor black">Todas as Notícias</h1>
            </div>
          </div>
          <div class="col-md-12 no-padd">
            <div id="accordion" class="myaccordion model-border">
              <div class="card border harvest-gold base">
                <div class="card-header desc-border-bottom" id="headingOne">
                  <h2 class="mb-0">
                    <button type="button" class="d-flex align-items-center justify-content-between btn btn-link" data-toggle="collapse" data-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne"  (click)="changePM()">
                      <span class="h2 text-white mt-2 font-italic">Filtros de Pesquisa</span>
                      <span class="fa-stack fa-sm" *ngIf="!pm_ctrl">
                        <fa-icon [icon]="faCircle" class="fas fa-circle fa-stack-2x"></fa-icon>
                        <fa-icon [icon]="faPlus" class="fas fa-plus fa-stack-1x fa-inverse"></fa-icon>
                      </span>
                      <span class="fa-stack fa-sm" *ngIf="pm_ctrl">
                        <fa-icon [icon]="faCircle" class="fas fa-circle fa-stack-2x"></fa-icon>
                        <fa-icon [icon]="faMinus" class="fas fa-plus fa-stack-1x fa-inverse"></fa-icon>
                      </span>
                    </button>
                  </h2>
                </div>
                <div id="collapseOne" class="collapse" aria-labelledby="headingOne" data-parent="#accordion">
                  <div class="col-12 col-md-4 col-lg-3 pt-10">
                    <div class="form-group text-center">
                      <label class="text-white border-bottom-news mb-3">Selecione a data da Notícia</label>
                      <input class="form-control" type="number" [(ngModel)]="year" (change)="updateFilter()">
                    </div>
                  </div>
                  <div class="card-body d-flex align-items-center justify-content-around flex-wrap">
                    <div class="col-md-2 border-right border-bottom">
                      <ul class="list-group list-group-flush text-white">
                        <li class="list-group-item no-padd d-table text-left"><span>Janeiro</span><input class="form-control col-3 " type="checkbox" style="height: 25px;" [(ngModel)]="months.jan" (change)="updateFilter()"></li>
                      </ul>
                      <ul class="list-group list-group-flush text-white">
                        <li class="list-group-item no-padd d-table text-left"><span>Fevereiro</span><input class="form-control col-3 " type="checkbox" style="height: 25px;" [(ngModel)]="months.fev" (change)="updateFilter()"></li>
                      </ul>                      
                    </div>
                    <div class="col-md-2 border-right border-bottom">
                      <ul class="list-group list-group-flush text-white">
                        <li class="list-group-item no-padd d-table text-left"><span>Março</span><input class="form-control col-3 " type="checkbox" style="height: 25px;" [(ngModel)]="months.mar" (change)="updateFilter()"></li>
                      </ul>
                      <ul class="list-group list-group-flush text-white">
                        <li class="list-group-item no-padd d-table text-left"><span>Abril</span><input class="form-control col-3 " type="checkbox" style="height: 25px;" [(ngModel)]="months.abr" (change)="updateFilter()"></li>
                      </ul>                      
                    </div>
                    <div class="col-md-2 border-right border-bottom">
                      <ul class="list-group list-group-flush text-white">
                        <li class="list-group-item no-padd d-table text-left"><span>Maio</span><input class="form-control col-3 " type="checkbox" style="height: 25px;" [(ngModel)]="months.mai" (change)="updateFilter()"></li>
                      </ul>
                      <ul class="list-group list-group-flush text-white">
                        <li class="list-group-item no-padd d-table text-left"><span>Junho</span><input class="form-control col-3 " type="checkbox" style="height: 25px;" [(ngModel)]="months.jun" (change)="updateFilter()"></li>
                      </ul>                      
                    </div>
                    <div class="col-md-2 border-right border-bottom">
                      <ul class="list-group list-group-flush text-white">
                        <li class="list-group-item no-padd d-table text-left"><span>Julho</span><input class="form-control col-3 " type="checkbox" style="height: 25px;" [(ngModel)]="months.jul" (change)="updateFilter()"></li>
                      </ul>
                      <ul class="list-group list-group-flush text-white">
                        <li class="list-group-item no-padd d-table text-left"><span>Agosto</span><input class="form-control col-3 " type="checkbox" style="height: 25px;" [(ngModel)]="months.ago" (change)="updateFilter()"></li>
                      </ul>                      
                    </div>
                    <div class="col-md-2 border-right border-bottom">
                      <ul class="list-group list-group-flush text-white">
                        <li class="list-group-item no-padd d-table text-left"><span>Setembro</span><input class="form-control col-3 " type="checkbox" style="height: 25px;" [(ngModel)]="months.set" (change)="updateFilter()"></li>
                      </ul>
                      <ul class="list-group list-group-flush text-white">
                        <li class="list-group-item no-padd d-table text-left"><span>Outubro</span><input class="form-control col-3 " type="checkbox" style="height: 25px;" [(ngModel)]="months.out" (change)="updateFilter()"></li>
                      </ul>
                    </div>
                    <div class="col-md-2">
                      <ul class="list-group list-group-flush text-white">
                        <li class="list-group-item no-padd d-table text-left"><span>Novembro</span><input class="form-control col-3 " type="checkbox" style="height: 25px;" [(ngModel)]="months.nov" (change)="updateFilter()"></li>
                      </ul>
                      <ul class="list-group list-group-flush text-white">
                        <li class="list-group-item no-padd d-table text-left"><span>Dezembro</span><input class="form-control col-3 " type="checkbox" style="height: 25px;" [(ngModel)]="months.dez" (change)="updateFilter()"></li>
                      </ul>                      
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row col-12 d-content pt-20">
            <ng-container *ngFor="let item of display">
              <div class="col-sm-3 col-md-6 col-lg-3 col-xl-3 col-12 d-flex mt-3 mb-1 card-expand">
                <div class="card shadow-card">
                  <img src="https://{{apiUrl}}/api/news/image/{{item.id}}/{{item.media.split(';')[0]}}" class="card-img-top backgroundColor img-h white base img-fluid rounded-0" alt="...">
                  <div class="card-body d-flex flex-column">
                    <p class="card-text p-font-title h2 textColor harvest-gold base card-text-limit">{{item.titulo}}</p>
                    <p class="card-text text-white text-justify text-limit">{{item.body}}</p>
                    <a href="/noticias/item?id={{item.id}}" class="btn btn-grad mt-auto">Ver Mais</a>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
        <div class="d-flex justify-content-center mt-20">
          <app-pagination [(current)]="current" [(pags)]="pags" [(total)]="noticias" [(display)]="display"></app-pagination>
        </div>
      </div>
    </div>
  </section>
</div>